<h2 mat-dialog-title>sdmadmin Auditing - Enter Required Info </h2>
<mat-dialog-content>
    <div style="padding-bottom:10px;">
        <!-- Row - 1 -->
        <div style="display: flex;flex-direction: row;width: 100%;">
            <div style="width: 50%;">
                <tyl-form-field label='Your Name' style="width: 90%;">
                    <input #nameRef matInput id='inpYourName' type='text' [(ngModel)]='auditLogin.AddedBy'
                        maxlength="75" #yournameRef required />
                </tyl-form-field>
            </div>
            <div  style="width: 50%;">
                <tyl-form-field label='Type' style="width: 90%;">
                    <mat-select id='ddlType' [(ngModel)]='auditLogin.Type' [required]="true" #typeRef>
                        <mat-option value='Normal Operation'>Normal Operation</mat-option>
                        <mat-option value='Issue Investigation'>Issue Investigation</mat-option>
                        <mat-option value='Training'>Training</mat-option>
                    </mat-select>
                </tyl-form-field>
            </div>
        </div>

        <div style="display: flex;flex-direction: row;width: 100%;">
            <div style="width: 50%;">
                <tyl-form-field label='Jira Number' style="width: 90%;">
                    <input #nameRef matInput id='inpJiraNumber' type='text' [(ngModel)]='auditLogin.JiraNumber'
                        maxlength="50" />
                </tyl-form-field>
            </div>
            <div  style="width: 50%;">
                <tyl-form-field label='CRM Number' style="width: 90%;">
                    <input #nameRef matInput id='inpCRMNumber' type='text' [(ngModel)]='auditLogin.CRMNumber'
                        maxlength="50" />
                </tyl-form-field>
            </div>
        </div>

        <div style="display: flex;flex-direction: row;width: 100%;">
            <div style="width: 100%;">
                <tyl-form-field label='Description' characters left style="width:95%;">
                    <textarea  matInput #descriptionRef id="inpDescription" rows="7" 
                        [(ngModel)]="auditLogin.Description" maxlength="8000" style="resize:none;" [required]="true">
                    </textarea>
                </tyl-form-field>
            </div>
        </div>

       
    </div>

</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="next arrow.png" label="Next" tabindex="0" (clickEvent)="nextClick();"></tyl-button>

    </div>
</mat-dialog-actions>
